import { baseApi as api } from "../baseApi";
export const addTagTypes = ["Dashboard"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getDashboard: build.query<GetDashboardApiResponse, GetDashboardApiArg>({
        query: () => ({ url: `/api/v1/vendor/dashboard` }),
        providesTags: ["Dashboard"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as dashboardApi };
export type GetDashboardApiResponse = /** status 200 OK */ DashboardData;
export type GetDashboardApiArg = void;
export type DashboardStatusData = {
  count?: number;
  status?:
    | "PENDING"
    | "CONFIRMED"
    | "PROCESSING"
    | "DISPATCHED"
    | "DELIVERED"
    | "CANCELLED";
};
export type VendorOrderData = {
  /** The customer's private link to this order's chat */
  chatUrl?: string;
  createdAt?: string;
  customerCompany?: string;
  customerEmail?: string;
  customerId?: number;
  customerName?: string;
  customerPhone?: string;
  id?: number;
  lastMessageAt?: string;
  /** Internal note, never shown to the customer */
  notes?: string;
  posOrderId?: string;
  /** When the chat link was last sent on Slack */
  slackNotifiedAt?: string;
  status?:
    | "PENDING"
    | "CONFIRMED"
    | "PROCESSING"
    | "DISPATCHED"
    | "DELIVERED"
    | "CANCELLED";
  summary?: string;
  /** Customer messages the vendor has not read */
  unreadCount?: number;
  updatedAt?: string;
};
export type DashboardData = {
  customers?: number;
  /** Orders neither delivered nor cancelled */
  openOrders?: number;
  /** Every status in lifecycle order, zeros included */
  ordersByStatus?: DashboardStatusData[];
  /** Orders placed in the last 7 days */
  ordersThisWeek?: number;
  /** At most 8 orders: unread first, then by last activity */
  recentConversations?: VendorOrderData[];
  /** Customer messages the vendor has not read yet */
  unreadMessages?: number;
};
export const { useGetDashboardQuery, useLazyGetDashboardQuery } =
  injectedRtkApi;
